var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"v-menu-item",on:{"click":_vm.handleClick}},[_c('span',{staticClass:"v-menu-item__content"},[_vm._t("default")],2),_c('span',{staticClass:"v-menu-icon__append"},[_c('v-icon-chevron-right')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }